<template>
  <div class="d-flex flex-column flex-column-fluid  qbank-section">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-dark">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الرئيسية</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button @click="$router.push('/qbank-acad-feature')" class="btn btn-light"
            style="font-weight: 600; padding: 8px 20px; margin-left: 15px; background: #d7d7d745;">
            رجوع <i class="fa fa-arrow-left" style="color: #07c232; margin-right: 10px"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isLoading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-12" v-if="isLoading == false && isLoggedIn == true">
            <div class="row">

              <div class="col-xl-12 mb-xl-10 qbank-summary">
                <!--begin::List widget 20-->
                <div v-if="!loadingBalance" class="container mt-5">
                  <!-- Title Section -->


                  <div class="row mb-4">
                    <div class="col-12 summary-title">
                      <i class="fa fa-desktop" aria-hidden="true"></i>
                      <h2 class="text-center">ملخص اختبارك</h2>
                    </div>
                  </div>


                  <div class="card shadow-sm mt-4">

                    <div class="card-body">
                      <div class="row">
                        <!-- نسبة الإجابات الصحيحة -->
                        <div class="col-md-4">
                          <div class="widget bg-white p-3 rounded text-center border border-success">
                            <i class="fas fa-check-circle text-success fa-2x mb-2"></i>
                            <h6 class="text-success">نسبة الإجابات الصحيحة</h6>
                            <strong class="text-success">{{ calculateCorrectPercentage() }}%</strong>
                          </div>
                        </div>

                        <!-- نسبة الإجابات الخاطئة -->
                        <div class="col-md-4">
                          <div class="widget bg-white p-3 rounded text-center border border-danger">
                            <i class="fas fa-times-circle text-danger fa-2x mb-2"></i>
                            <h6 class="text-danger">نسبة الإجابات الخاطئة</h6>
                            <strong class="text-danger">{{ calculateIncorrectPercentage() }}%</strong>
                          </div>
                        </div>

                        <!-- نسبة الإجابة الإجمالية -->
                        <div class="col-md-4">
                          <div class="widget bg-white p-3 rounded text-center border border-info">
                            <i class="fas fa-tasks text-info fa-2x mb-2"></i>
                            <h6 class="text-info">نسبة الإجابات الكلية</h6>
                            <strong class="text-info">{{ calculateAnsweredPercentage() }}%</strong>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- Totals Section -->
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <div class="card shadow-sm mt-2">
                        <div class="card-header bg-dark text-white">
                          <h5><i class="fas fa-chart-pie"></i> الإجماليات</h5>
                        </div>
                        <div class="card-body">
                          <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-list-ol text-dark"></i> إجمالي الأسئلة</span>
                              <strong>{{ totals.total_questions }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-check-circle text-dark"></i> الأسئلة التي تم الإجابة
                                عليها</span>
                              <strong>{{ totals.answered_questions }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-times-circle text-warning"></i> الأسئلة التي لم تتم الإجابة
                                عليها</span>
                              <strong>{{ totals.unanswered_questions }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-thumbs-up text-success"></i> الإجابات الصحيحة</span>
                              <strong>{{ totals.correct_answers }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-thumbs-down text-danger"></i> الإجابات الخاطئة</span>
                              <strong>{{ totals.incorrect_answers }}</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-clock text-info"></i> الوقت المتوقع</span>
                              <strong>{{ formatTime(totals.estimated_time) }} دقائق</strong>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                              <span><i class="fas fa-stopwatch text-dark"></i> الوقت الفعلي</span>
                              <strong>{{ formatTime(totals.actual_time) }} دقائق</strong>
                            </li>
                          </ul>

                        </div>
                      </div>
                    </div>

                    <!-- Lessons Section -->
                    <div class="col-md-6">
                      <div class="card shadow-sm mt-2">
                        <div class="card-header bg-dark text-white">
                          <h5><i class="fas fa-book"></i> الدروس</h5>
                        </div>
                        <div class="card-body">
                          <ul class="list-group">
                            <li class="list-group-item">
                              <br>
                              <strong>{{ lessons[0].title }}</strong>
                              <br><br>
                              <div class="d-flex justify-content-between m-3">
                                <span><i class="fas fa-check-circle text-success"></i> الإجابات الصحيحة: {{
                                  lessons[0].correct_answers }}</span>
                                <span><i class="fas fa-times-circle text-danger"></i> الإجابات الخاطئة: {{
                                  lessons[0].incorrect_answers }}</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="card shadow-sm mt-2">

                        <div class="card-body" style="text-align: center;">
                          <img src="assets/img/good-feedback.png" alt="تحليل الأداء" class="modal-icon mb-3" />

                          <h5 class="modal-title mb-3" id="performanceModalLabel">تحليل الأداء</h5>

                          <!-- الزر يظهر فقط في حالة عدم وجود بيانات -->
                          <button v-if="!performance_analysis && !loadingPerformance"
                            class="btn btn-success performance-btn mt-2" @click="performanceAnlysis">
                            <i class="bi bi-bar-chart-line me-2"></i>
                            إضغط هنا لتحليل الأداء
                          </button>

                          <!-- Loader -->
                          <div v-if="loadingPerformance" class="loader-container my-4">
                            <div class="spinner-border text-success" role="status">
                              <span class="sr-only">جاري التحميل...</span>
                            </div>
                            <p class="mt-2">جاري تحميل تحليل الأداء...</p>
                          </div>

                          <!-- المحتوى -->
                          <div v-else>
                            <p class="text-grey" v-if="displayedText">{{ displayedText }}</p>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- Loading Spinner -->
                <div v-if="loadingBalance" class="text-center">
                  <i class="fas fa-spinner fa-spin fa-3x"></i>
                </div>

                <!--end::List widget 20-->
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->

  </div>
  <!-- مودال تحليل الأداء -->
  <!-- Modal -->
  <div class="modal fade" id="performanceModal" tabindex="-1" aria-labelledby="performanceModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content p-3">
        <div class="modal-body text-center position-relative">

          <!-- أيقونة في الأعلى -->
          <img src="assets/img/good-feedback.png" alt="تحليل الأداء" class="modal-icon mb-3" />

          <h5 class="modal-title mb-3" id="performanceModalLabel">تحليل الأداء</h5>

          <!-- Loader -->
          <div v-if="loadingPerformance" class="loader-container my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">جاري التحميل...</span>
            </div>
            <p class="mt-2">جاري تحميل تحليل الأداء...</p>
          </div>

          <!-- المحتوى -->
          <div v-else>
            <p class="text-grey" v-if="performance_analysis">{{ performance_analysis }}</p>
            <p class="text-danger" v-else>لا توجد بيانات لعرضها.</p>
          </div>

          <!-- زر الإغلاق -->
          <button type="button" class="btn btn-secondary mt-4" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
export default {
  name: "QbankSummary",

  data() {
    return {
      categories: [],
      subCategories: [],
      isLoading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      performance_analysis: null,
      displayedText: "",
      loadingPerformance: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      qbankId: this.$route.query.qbank,

    };
  },
  mounted() {
    this.getSummary();
  },
  methods: {

    calculateCorrectPercentage() {
      return this.totals.total_questions
        ? ((this.totals.correct_answers / this.totals.total_questions) * 100).toFixed(2)
        : 0;
    },
    calculateIncorrectPercentage() {
      return this.totals.total_questions
        ? ((this.totals.incorrect_answers / this.totals.total_questions) * 100).toFixed(2)
        : 0;
    },
    calculateAnsweredPercentage() {
      return this.totals.total_questions
        ? ((this.totals.answered_questions / this.totals.total_questions) * 100).toFixed(2)
        : 0;
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs < 10 ? '0' + secs : secs}`;
    },

    async getSummary() {
      this.loadingBalance = true;
      try {
        const response = await fetch(
          `${apiUrl}/qbanks/${this.qbankId}/summary`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch summary");
        }

        // إذا كانت الاستجابة ناجحة
        this.isLoggedIn = true;
        const data = await response.json();

        // تخزين البيانات المستخلصة في متغير totals
        this.totals = data.totals;
        this.performance_analysis = data.performance_analysis;
        if (this.performance_analysis) {
          this.typeText(this.performance_analysis);
        }
        // تخزين الدروس
        this.lessons = data.lessons;

      } catch (error) {
        console.error("Error fetching summary:", error);
      } finally {
        this.loadingBalance = false;
        this.isLoading = false;
      }
    },
    async performanceAnlysis() {
      this.loadingPerformance = true;

      try {
        const response = await fetch(`${apiUrl}/qbanks/${this.qbankId}/performance-analysis`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("فشل في جلب تحليل الأداء");
        }

        const data = await response.json();
        this.performance_analysis = data.report;

        // بعد الحصول على البيانات، قم بعرض النص تدريجياً
        this.typeText(this.performance_analysis);
      } catch (error) {
        console.error("Error fetching summary:", error);
      } finally {
        this.loadingPerformance = false;
      }
    },
    typeText(text) {
      this.displayedText = "";
      let index = 0;

      const typingEffect = () => {
        if (index < text.length) {
          this.displayedText += text.charAt(index);
          index++;
          setTimeout(typingEffect, 25); // سرعة الكتابة
        }
      };
      typingEffect();
    },
  }

};
</script>

<style scoped>
.performance-btn {
  background-color: #07c232;
  border-color: #07c232;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.performance-btn:hover {
  background-color: #05a627;
  border-color: #05a627;
}

.performance-btn i {
  font-size: 1.3rem;
  vertical-align: middle;
}

.card {
  border-radius: 10px;
}

.card-header {
  border-bottom: 2px solid #ddd;
}

.list-group-item {
  padding: 10px 15px;
}

.list-group-item strong {
  font-size: 1.2em;
}

.text-center {
  font-weight: 500;
  color: #818181 !important;
  ;
}

h2 {
  font-size: 2rem;
  font-weight: 700;
}

.modal-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-top: -20px;
}

.modal-content {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
